import { ReactNode } from 'react';

import { ReportsMessage } from '../../../types/SpecificReportMessage';
import { SupplierSpecificStatisticsMessage } from '../../../types/StatisticsMessage';
import { DynamicFilterContainer, Filter } from '../../cdl/Filter/DynamicFilterContainer/DynamicFilterContainer';
import { FilterMultiSelectFull } from '../../cdl/Filter/FilterMultiSelectFull/FilterMultiSelectFull';
import { translate } from '../../common/helpers/translate.helper';

interface CustomersTabFilterProps {
    allEntries: SupplierSpecificStatisticsMessage['customer'];
    children: (filteredEntries: SupplierSpecificStatisticsMessage['customer']) => ReactNode;
}

export const CustomersTabFilter = ({ children, allEntries }: CustomersTabFilterProps) => {
    const customerFilter: Filter<string, ReportsMessage> = {
        filterFn: (values, entry) => {
            return values.includes(entry.context.id);
        },
        component: (values, setValues) => {
            const availableOptions = Array.from(new Set(allEntries.map((entry) => entry.context.id))).map(
                (customerId) => ({
                    label: allEntries.find((entry) => entry.context.id === customerId)?.context.name ?? '',
                    value: customerId,
                })
            );

            return (
                <FilterMultiSelectFull
                    options={availableOptions}
                    values={values}
                    onChange={setValues}
                    label={translate('reporting.filter.customer.title')}
                    filterByLabel={translate('reporting.filter.customer.filterByCustomer')}
                    filterPlaceholder={translate('reporting.filter.customer.searchForCustomer')}
                />
            );
        },
    };

    return (
        <DynamicFilterContainer allEntries={allEntries} filters={{ customer: customerFilter }}>
            {children}
        </DynamicFilterContainer>
    );
};
